import { PLCcollectSettingType } from "../components/Pages/MeasureSetting/CollectSetting/CollectSettingDefine";
import { ErrorCode, ResponceDataType} from "../ErrorCode"

export type ImageFileType = {
  FilePath: string;
  SearchFileName: string;
  ResponceData: ResponceDataType;
  Base64ImageData: string;
  CollectSettingModel: PLCcollectSettingType;
  FileDate: string;
}


/**
 * * 三次元グラフ画像パス取得
 * @param plcNo PLC番号
 * @param aiCardNo AICARD番号
 * @param aiChannelNo チャンネル番号
 * @param selectDate　検索対象日時情報
 * @param searchMode　検索モード　0:日時指定　1:日のみ指定
 * @returns
 */
export const GetThreeDimensionImagePath = (plcNo : string,  aiCardNo : string ,aiChannelNo : string  , selectDate : string ,searchMode:number )  : Promise<ImageFileType> => {
  return new Promise((resolve, reject) => {
    const query_params = new URLSearchParams({
      plcNo: plcNo,
      aiCardNo: aiCardNo,
      aiChannelNo: aiChannelNo,
      selectDate: selectDate,
      searchMode : searchMode.toString()
    });
    console.debug(["ThreeDimensionImage - ulr", "api/ThreeDimensionImage?" + query_params])
    fetch("api/ThreeDimensionImage?" + query_params)
      .then((res) => {
        if (!res.ok) {
          let message = `データが見つかりませんでした status:${res.status}`;
          reject(message);
        } else {
          return res.json();
        }
      })
      .then((result: ImageFileType) => {
        console.debug(["ThreeDimensionImage - result", result]);
        if (result.ResponceData.ErrorCode === ErrorCode.ERR_CODE_NONE) {
          resolve(result);
        }
        else {
          reject(result.ResponceData.ErrorMessage);
        }
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      })
  })
}
/**
 * 三次元グラフ画像の情報取得
 * @param fileDate 取得ファイル時間
 * @param collectSettingModel COL_SETの情報 
 * @returns 
 */
export const GetThreeDimensionImageTitle =(fileDate: string, collectSettingModel?: PLCcollectSettingType):string => {
  if(collectSettingModel === undefined){
    return '';
  }
  else{
    const imageTitle: string =`${collectSettingModel.MachineNo}_${collectSettingModel.MachineName}_${collectSettingModel.ItemName}_${fileDate}`;
    return imageTitle;
  }
}